import Vue, { CreateElement, VNode, VueConstructor } from "vue";
import { getComponent } from "@/lib/requireContextHelpers";
import { FormFields, ListField } from "@/types";

import * as BankPayout from "./components/BankPayout";
import * as GustoPayout from "./components/GustoPayout";
import * as OtherPayout from "./components/OtherPayout";
import * as PayPalPayout from "./components/PayPalPayout";

const modules = [BankPayout, GustoPayout, OtherPayout, PayPalPayout] as {
  default: { component: VueConstructor<Vue>; listField: ListField; formFields: FormFields };
  selector: (item: unknown) => boolean;
}[];

export function getListFields() {
  return modules.map(module => module.default.listField);
}

export default (selectedPayoutSystem: string | null) =>
  getComponent(modules, selectedPayoutSystem, {
    component: Vue.extend({
      render(h: CreateElement): VNode {
        return h();
      },
    }),
    listField: { text: "", value: "" },
    formFields: [],
  });
